import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { TableViewStore } from 'src/app/shared/services/table-view/table-view.state';

export const tableViewResolver: ResolveFn<boolean> = () => {
  const tableViewStore = inject(TableViewStore);
  tableViewStore.fetchTableViews({});
  return true;
};
